import {Component} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {ApplicationSettingsService} from 'src/app/core/application-settings/application-settings.service';
import {DirectoryService} from 'src/app/core/application-settings/repository-manager/directory.service';
import {GuideComponent} from 'src/app/guide/guide.component';
import {UserProfile} from '../models/user-profile';
import {AuthenticationService} from '../services/authentication.service';
import {CurrentUserService} from '../services/current-user.service';
import {ConfigService} from '../services/config.service';
import {ThemeService} from '../services/theme.service';

@Component({
    selector: 'app-menu-bar',
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.less']
})
export class MenuBarComponent {

      constructor(public router: Router,
                public authenticationService: AuthenticationService,
                private currentUserService: CurrentUserService,
                private applicationSettingsService: ApplicationSettingsService,
                public config: ConfigService,
                public theme: ThemeService,
                public dialog: MatDialog) {
    }

    isAdministrationTabShowable() {
        const role = this.currentUserService.getCurrentUser()?.role;
        return role != UserProfile.CP_CDS
            && role != UserProfile.CP_SNCF
            && role != UserProfile.GUEST_SNCF
            && role != UserProfile.GUEST_CDS;
    }

    isCollectedDataTabHidden() {
        const role = this.currentUserService.getCurrentUser()?.role;
        return !this.applicationSettingsService.getApplicationSettings().enableCollectedDataTab &&
            role != UserProfile.ADMIN;
    }

    isFacturationHidden() {
        return this.currentUserService.getCurrentUser()?.role != UserProfile.ADMIN;
    }

    openGuide(s: string) {
        this.dialog.open(GuideComponent, {
            data: s
        })
    }


}
